<template>
  <header class="masthead" id="top">
    <swiper v-if="banners.length>0" :options="swiperOption">
      <swiper-slide v-for="(banner, i) in banners" :key="i">
        <div class="bannerDiv">
          <img class="banner" :src="banner" />
        </div>
      </swiper-slide>
      <div class="swiper-pagination grey" slot="pagination"></div>
    </swiper>
  </header>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'Top',
  components: {
      swiper,
      swiperSlide
  },
  props: {
    banners: Array,
  },
  data() {
    return {
      swiperOption: {
        effect: 'fade',
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  }
}
</script>

<style scoped>
.bannerDiv {
  width:100%;
}
@media (min-width: 992px) {
  .bannerDiv {
    height:calc(100vh-56px);
  }
}
.banner {
  width: 100%;
  height: 100%;
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color:  rgba(235, 159, 18, 0.842);;
}
</style>